import React from 'react';

import { Typography } from '@mui/material';
import CicEnteredBy from 'app/shared/components/CicEnteredBy';
import CicValueChange from 'app/shared/components/CicValueChange';

import { getCicDisplayValue } from 'utils/cicReason';

import CicEditChangeButton from './components/CicEditChangeButton';
import { commentTextStyles, getWrappingCellStyles } from './LoanCicHistory.styles';

export const renderChangeCell = ({ oldDisplay, newDisplay }) => (
  <CicValueChange newDisplay={newDisplay} oldDisplay={oldDisplay} />
);

export const renderCommentCell = ({ comment }) => (
  <Typography sx={commentTextStyles} variant="regular14">
    {getCicDisplayValue(comment)}
  </Typography>
);

export const renderEnteredByCell = ({ changedByName, changedDate }) => (
  <CicEnteredBy date={changedDate} name={changedByName} />
);

export const getCicCommentColumnWidth = hasActions => (hasActions ? '20%' : '26%');

export const getCicActionsColumn = ({ getIsEditable, getDataTestId, onEdit }) => ({
  label: 'Actions',
  width: '88px',
  align: 'right',
  customStyles: getWrappingCellStyles,
  content: row =>
    getIsEditable(row) && (
      <CicEditChangeButton change={row} dataTestId={getDataTestId(row.id)} onEdit={onEdit} />
    ),
});
